import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { URL } from "../../../constants/URL";
import CS from "../../../services/commonService";
import BreadCrumbs from "../../common/breadcrumbs";
import { useFormik } from "formik";
import { contactSchema } from "../../../validations/generalSettingsValidations";
import Select from "react-select";
import {
	useGetContactDetails,
	useUpdateContactDetails,
} from "../../../queryHooks/useSettings";
import { useStore } from "../../../zustand/store";
import PhoneNumber from "../../common/PhoneNumber";

//	Component starts
const ContactSettings = () => {
	const setLoading = useStore((state) => state.setLoading);
	const [countryCode, setCountryCode] = useState({ label: "+1", value: "+1" });

	const { data: getContactDetails, refetch } = useGetContactDetails();
	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: {
			email: getContactDetails?.data?.email,
			mobile: getContactDetails?.data?.mobile,
		},
		validationSchema: contactSchema,
		enableReinitialize: true,
		onSubmit: (value) => {
			updateContactDetails({
				email: value.email,
				mobile: value.mobile,
			});
			setLoading(true);
		},
	});

	const {
		mutateAsync: updateContactDetails,
		error: errorUpdateContactDetails,
		data: dataUpdateContactDetails,
	} = useUpdateContactDetails();

	useEffect(() => {
		if (dataUpdateContactDetails) {
			setLoading(false);
			if (dataUpdateContactDetails.status === "success") {
				CS.showSuccessMessage(dataUpdateContactDetails.message);
				refetch();
			} else if (dataUpdateContactDetails.status === "fail") {
				CS.showErrorMessage(dataUpdateContactDetails.message);
			}
		}
	}, [dataUpdateContactDetails]);

	useEffect(() => {
		if (errorUpdateContactDetails) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateContactDetails.response?.data?.message);
		}
	}, [errorUpdateContactDetails]);

	return (
		<>
			<BreadCrumbs title="Settings" data={[{ label: "Contact Details" }]} />
			<div className="card strip-card">
				<form onSubmit={(event) => handleSubmit(event)}>
					<div id="accordion" className="collapse-setting">
						<div className="card mb-5">
							<div
								id="collapseOne"
								className="collapse show"
								aria-labelledby="headingOne"
								data-parent="#accordion"
							>
								<div className="row">
									<div className="col-md-12">
										<div className="card-strip">
											<div className="modal-header p-0 pb-3 mb-4 w-100">
												<h5 className="modal-title">Contact Details</h5>
											</div>
											<div className="row">
												<div className="form-group col-md-6">
													<label htmlFor="emailId">
														Email<sup className="text-danger">*</sup>
													</label>
													<input
														className="form-control"
														id="email"
														name="email"
														type="email"
														value={values.email}
														onChange={handleChange}
														placeholder="Enter email address"
													/>
													<span className="text-danger error-msg">
														{errors.email && touched.email
															? errors.email
															: null}
													</span>
												</div>
												<div className="form-group col-md-6">
													<div className="row justify-content-center">
														{/* <div className="col-md-3">
															<label className="mb-1" htmlFor="phonelId">
																Country Code<sup className="text-danger">*</sup>
															</label>
															<Select
																className="default-select"
																value={countryCode}
																// options={codeOptions}
																isDisabled={true}
																onChange={(val) => setCountryCode(val)}
															></Select>
														</div>
														<div className="col-md-9">
															<label className="mb-1" htmlFor="phonelId">
																Phone Number<sup className="text-danger">*</sup>
															</label>
															<input
																className="form-control"
																type="number"
																value={values.mobile}
																onChange={handleChange}
																id={"mobile"}
																name={"mobile"}
																onInput={(e) =>
																	(e.target.value = e.target.value.slice(0, 10))
																}
																placeholder="Enter phone number"
															/>
															<span className="text-danger error-msg">
																{errors.mobile && touched.mobile
																	? errors.mobile
																	: null}
															</span>
														</div> */}
														<div className="col-md-12">
															<div className="col-md-12">
																<label className="mb-1" htmlFor="phonelId">
																	Phone Number
																</label>
																<PhoneNumber
																	value={values.mobile}
																	onChange={(val) => {
																		let event = {
																			target: {
																				name: "mobile",
																				value: val ? val : "",
																			},
																		};
																		handleChange(event);
																	}}
																/>
																<span className="text-danger d-block">
																	{errors.mobile && errors.mobile
																		? errors.mobile
																		: null}
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="text-right mt-2">
						<button className="btn btn-primary glow-primary mr-4" type="submit">
							Save Changes
						</button>
						<Link to={URL.dashboard} className="btn btn-outline-primary">
							Cancel
						</Link>
					</div>
				</form>
			</div>
		</>
	);
};

export default ContactSettings;
